import React, { useState, useEffect, useRef } from 'react';
import { MdAdd } from 'react-icons/md';
import { Button } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import TmFilter from '../ReusableComponents/TmFilter';
import AntdModalComp from '../ReusableComponents/AntdModalComp';
import { DeletePopup } from '../ReusableComponents/DeletePopup';
import { toastError, toastSuccess, toastWarn } from '../Toast/ToastComponent';
import { Modal } from 'antd';
import { getSurvey } from '../../store/reducers/actionPermission';
import {
  SURVEY_COMPLETION_STATUS,
  ACTIVE_STATUS,
} from '../../constant/constant';
import { surveyHeader } from '../../constant/tableHeader';
import Loader from '../ReusableComponents/Loader';
import TmMasterTable from '../ReusableComponents/TmMasterTable';
import SearchInput from '../ReusableComponents/SearchInput';
import SurveyApi from '../../Api/SurveyApi';
import { useAuth } from '../../Context/AuthContext';

let filterArray = [
  {
    options: [
      ...SURVEY_COMPLETION_STATUS,
      { label: 'In Progress', value: 'In progress', id: 4 },
    ],
    placeholder: 'Completion Status',
    controlName: 'survey_status',
    input: 'select',
    allowClear: true,
    size: 'small',
    style: { width: 150 },
    col: 2,
  },
  {
    options: ACTIVE_STATUS,
    placeholder: 'Status',
    controlName: 'activeStatus',
    input: 'select',
    allowClear: true,
    defaultValue: true,
    size: 'small',
    style: { width: 140 },
    col: 2,
  },
  {
    order: 1,
    col: 'auto',
    className: 'ms-auto pe-0',
    input: 'button',
    type: 'dashed',
    htmlType: 'button',
    text: 'Reset',
  },
];

const SurveyComp = () => {
  const debounceTimeoutRef = useRef(null);
  const allDataRef = useRef([]);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const permission = useSelector(getSurvey);
  const { authState } = useAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalHeader, setModalHeader] = useState('');
  const [modalData, setModalData] = useState({});
  const [filterArr, setFilterArr] = useState({
    search: searchParams.get('search') || '',
    survey_status: searchParams.get('survey_status') || '',
    activeStatus:
      searchParams.get('activeStatus') !== null
        ? searchParams.get('activeStatus') === 'true'
          ? true
          : searchParams.get('activeStatus') === 'false'
            ? false
            : true
        : true,
    month: searchParams.get('month') ? Number(searchParams.get('month')) : '',
    year: searchParams.get('year') ? Number(searchParams.get('year')) : '',
  });
  const hasFetched = useRef(false);
  const [buttonPermission, setButtonPermissions] = useState({
    add: false,
    edit: false,
    delete: undefined,
    view: false,
  });
  useEffect(() => {
    if (hasFetched.current) return;

    hasFetched.current = true;
    if (permission) handlePermission();
    if (authState?.id) {
      getSurveyList(
        authState.id,
        filterArr.search,
        filterArr.survey_status,
        filterArr.activeStatus,
        filterArr.month,
        filterArr.year,
      );
    }
  }, [permission, authState]);
  const handlePermission = () => {
    if (!permission?.checked) return navigate('/');

    const obj = {};
    permission.actions.forEach((el) => {
      obj[el.statename.toLowerCase()] = el.checked;
    });

    setButtonPermissions(obj);
  };
  const getSurveyList = async (
    userId,
    searchQuery = '',
    statusQuery = '',
    activeStatusQuery = '',
    monthQuery = '',
    yearQuery = '',
  ) => {
    try {
      setLoading(true);
      const payload = {
        user_id: userId,
        limit: 10000,
        page: 1,
        search: searchQuery || '',
        survey_status: statusQuery || '',
        month: monthQuery || '',
        year: yearQuery || '',
        ...(activeStatusQuery !== null &&
        activeStatusQuery !== undefined &&
        activeStatusQuery !== ''
          ? { status: activeStatusQuery }
          : {}),
      };
      const res = await SurveyApi.getList(payload);
      if (res?.data?.success) {
        const rows = res.data.result?.rows || [];
        const mappedData = rows.map((item, index) => ({
          id: item.id,
          serialNo: index + 1,
          title: item.title,
          description: item.description,
          createdAt: item.createdAt,
          question_count: item.question_count,
          updatedAt: item.updatedAt,
          status: item.activeStatus,
          completion_status: item.completion_status,
          Start_date: item.Start_date,
          end_date: item.end_date,
          departmentsID: [1],
          period:
            item.PeriodModel?.period_name ||
            item.PeriodModel?.periodName ||
            item['PeriodModel.period_name'] ||
            item['PeriodModel.Period_Name'] ||
            item.PeriodModel?.Period_Name ||
            '',
          approval_status: item.approval_status || '',
        }));

        allDataRef.current = mappedData;
        setData(mappedData);
      } else {
        setData([]);
        toastWarn(res?.data?.message || 'No data found');
      }
    } catch (err) {
      toastError(err?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };
  const handleSearchChange = (value) => {
    const nextState = { ...filterArr, search: value };
    setFilterArr(nextState);
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        value ? next.set('search', value) : next.delete('search');
        next.set('pageNumber', 1);
        return next;
      },
      { replace: true },
    );
    if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current);
    debounceTimeoutRef.current = setTimeout(() => {
      if (authState?.id) {
        getSurveyList(
          authState.id,
          nextState.search,
          nextState.survey_status,
          nextState.activeStatus,
          nextState.month,
          nextState.year,
        );
      }
    }, 400);
  };
  const handleFilterChange = (obj) => {
    if (Object.keys(obj).includes('submit')) return;
    const nextState = { ...filterArr, ...obj };
    setFilterArr(nextState);
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        Object.entries(obj).forEach(([k, v]) => {
          if (v === null || v === undefined || v === '') {
            next.delete(k);
          } else {
            next.set(k, String(v));
          }
        });
        next.set('pageNumber', 1);
        return next;
      },
      { replace: true },
    );
    if (authState?.id) {
      getSurveyList(
        authState.id,
        nextState.search,
        nextState.survey_status,
        nextState.activeStatus,
        nextState.month,
        nextState.year,
      );
    }
  };
  const toggleModal = (type, value) => {
    if (type === 'Close') {
      setModal(false);
      setModalData({});
      return;
    }

    if (type === 'Add') {
      navigate('/survey/create');
    }

    if (type === 'Edit' && value) {
      navigate(`/survey/edit/${value.id}`);
    }

    if (type === 'View' && value) {
      navigate(`/survey/preview/${value.id}`);
    }
  };

  const callDelete = async (id) => {
    await DeletePopup(async (ok) => {
      if (!ok) return;

      try {
        const res = await SurveyApi.delete(id);

        if (res.data.success) {
          toastSuccess(res.data.message);

          if (authState?.id) {
            getSurveyList(
              authState.id,
              filterArr.search,
              filterArr.survey_status,
              filterArr.activeStatus,
            );
          }
        } else {
          toastWarn(res.data.message);
        }
      } catch (err) {
        toastError(err?.message || 'Something went wrong');
      }
    });
  };
  const handleStatusToggle = (row) => {
    const isCurrentlyActive =
      row.status === 'Active' ||
      row.status === 1 ||
      row.status === true ||
      String(row.status).toLowerCase() === 'active';
    const newStatus = isCurrentlyActive ? 'inactive' : 'active';

    Modal.confirm({
      title: `Are you sure you want to ${newStatus === 'inactive' ? 'Deactivate' : 'Activate'} this survey?`,
      onOk: async () => {
        try {
          const payload = {
            id: row.id,
            status: newStatus === 'active' ? true : false,
          };
          const res = await SurveyApi.status(payload);
          if (res.data?.success) {
            toastSuccess(
              `Survey ${newStatus === 'inactive' ? 'Deactivated' : 'Activated'} successfully`,
            );
            if (authState?.id) {
              getSurveyList(
                authState.id,
                filterArr.search,
                filterArr.survey_status,
                filterArr.activeStatus,
              );
            }
          } else {
            toastWarn(res.data?.message);
          }
        } catch (err) {
          toastError(err?.message || 'Something went wrong');
        }
      },
    });
  };
  return (
    <div>
      <div className="d-md-flex align-items-center mb-2">
        <h5 className="mb-0">Survey</h5>
        <div className="ms-auto d-flex align-items-center">
          <div className="me-2">
            <SearchInput
              placeholder="Search"
              value={filterArr.search}
              onSearchChange={handleSearchChange}
            />
          </div>
          {buttonPermission.add && (
            <Button
              type="primary"
              icon={<MdAdd size={20} />}
              onClick={() => navigate('/survey/create')}
            />
          )}
        </div>
      </div>
      <div className="mt-2 mb-2">
        <TmFilter
          filterArray={filterArray.map((f) => {
            if (f.controlName === 'survey_status')
              return {
                ...f,
                defaultValue: filterArr.survey_status || undefined,
              };
            if (f.controlName === 'activeStatus')
              return { ...f, defaultValue: filterArr.activeStatus };
            return f;
          })}
          handleFilterChange={handleFilterChange}
        />
      </div>
      {loading ? (
        <Loader />
      ) : (
        <TmMasterTable
          buttonPermission={buttonPermission}
          rows={data}
          columns={surveyHeader}
          custom={['action']}
          toggleModal={toggleModal}
          handleDelete={callDelete}
          handleStatus={handleStatusToggle}
        />
      )}
      <AntdModalComp
        width="60%"
        modalOpen={modal}
        toggleModal={() => toggleModal('Close')}
        modalHeader={modalHeader}
      />
    </div>
  );
};
export default SurveyComp;
